import useMainPageState from "components/Admin/MainPage/MainPage.reducer";
import { MainPageStates } from "components/Admin/MainPage/MainPage.constants.js";
import DonationsBlock from "components/Admin/DonationsBlock";
import TokensBlock from "components/Admin/TokensBlock";
import SettingsBlock from "components/Admin/SettingsBlock/SettingsBlock";
import { DonationFolders } from "components/Admin/DonationsBlock/DonationsBlock.constants";

import "./MainPage.scss";

const { ARCHIVED } = DonationFolders;

export default function MainPage({
  tokens, setTokens,
  goals, setGoals,
  rules, setRules,
  donations, donationsHandlers,
  animations, setAnimations,
}) {
  const [state, handlers] = useMainPageState();
  const { switchToDonations, switchToArchive, switchToSettings, switchToTokens } = handlers;

  const donationsButtonClassName = `header-button${state === MainPageStates.DONATIONS ? " header-button_active" : ""}`;
  const archiveButtonClassName = `header-button${state === MainPageStates.ARCHIVE ? " header-button_active" : ""}`;
  const settingsButtonClassName = `header-button${state === MainPageStates.SETTINGS ? " header-button_active" : ""}`;
  const tokensButtonClassName = `header-button header-button_tokens ${state === MainPageStates.TOKENS ? " header-button_active" : ""}`;

  return (
    <div className="mainPage">
      <div className="header">
        <div className="header-buttons">
          <button className={donationsButtonClassName} onClick={switchToDonations}>DONATIONS</button>
          <button className={archiveButtonClassName} onClick={switchToArchive}>ARCHIVE</button>
          <button className={settingsButtonClassName} onClick={switchToSettings}>SETTINGS</button>
          <button className={tokensButtonClassName} onClick={switchToTokens}>TOKENS</button>
        </div>
      </div>
      { state === MainPageStates.DONATIONS ? <DonationsBlock state={donations} handlers={donationsHandlers}/> : "" }
      { state === MainPageStates.ARCHIVE ? <DonationsBlock state={donations} handlers={donationsHandlers} initialFolder={ARCHIVED} /> : "" }
      { state === MainPageStates.SETTINGS ? <SettingsBlock { ...{ goals, setGoals, rules, setRules, animations, setAnimations }} /> : "" }
      { state === MainPageStates.TOKENS ? <TokensBlock { ...{ tokens, setTokens }} /> : "" } 
    </div>
  );
}
